import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import FaqAccordion from "@/components/feature/FaqAccordion";
import { faqs } from "@/mocks/faqs";

export default function FaqPreview() {
  const items = faqs.slice(0, 5);

  return (
    <section className="border-b border-background-200 bg-background-50">
      <div className="px-4 py-12 md:px-8 md:py-16">
        <div className="grid gap-8 lg:grid-cols-[0.8fr_1.2fr]">
          <div className="lg:sticky lg:top-28 lg:self-start">
            <SectionHeading
              eyebrow="FAQ"
              title="关于追踪的常见疑问"
              description="关于更新频率、热度值含义、信息来源与纠错方式，这里先回答最常被问到的几个问题。"
            />
            <Link
              to="/faq"
              className="mt-6 inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-5 py-2.5 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
            >
              查看全部问答
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          </div>
          <FaqAccordion items={items} defaultOpenId={items[0]?.id} />
        </div>
      </div>
    </section>
  );
}